"use strict";
exports.__esModule = true;
exports.CoreGeoChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var GeoValidatorHOC_1 = require("./geoChart/GeoValidatorHOC");
var GeoChartOptionsWrapper_1 = require("./geoChart/GeoChartOptionsWrapper");
var MapboxTokenProvider_1 = require("./MapboxTokenProvider");
var flowRight_1 = tslib_1.__importDefault(require("lodash/flowRight"));
var WrappedCoreGeoChart = flowRight_1["default"](sdk_ui_theme_provider_1.withTheme, MapboxTokenProvider_1.withMapboxToken, GeoValidatorHOC_1.geoValidatorHOC, sdk_ui_1.withEntireDataView)(GeoChartOptionsWrapper_1.GeoChartOptionsWrapper);
/**
 * @internal
 */
exports.CoreGeoChart = function (props) { return (react_1["default"].createElement(sdk_ui_theme_provider_1.ThemeContextProvider, { theme: props.theme || {}, themeIsLoading: false },
    react_1["default"].createElement(WrappedCoreGeoChart, tslib_1.__assign({}, props)))); };
//# sourceMappingURL=CoreGeoChart.js.map